import { useFormContext } from '../dynamic-form';

export function FormDebugger() {
  const form = useFormContext();
  return (
    <form.Subscribe selector={(state) => state}>
      {(state) => <pre>{JSON.stringify(state, null, 4)}</pre>}
    </form.Subscribe>
  );
}
